<table class="excluded-table">
  <thead>
    <tr>
      <th>Recipient</th>
      <th>Donor</th>
      <th class="hide-xs">Date Excluded</th>
      <th>Reason Excluded</th>
      <th></th>
    </tr>
  </thead>

  <tbody>
    <tr *ngIf="busy">
      <td colspan="7" class="loading-cell">
        <mat-spinner></mat-spinner>
      </td>
    </tr>

    <tr *ngIf="!excludedCombinations?.length">
      <td colspan="7" class="no-results">
        <i>No results found that match the current selection criteria</i>
      </td>
    </tr>

    <ng-container *ngFor="let x of excludedCombinations; trackBy: key">
      <tr (click)="showExcludedDetails(x)"
          [class.clickable]="true"
          [class.has-comments]="x.comments"
          [class.selected]="selectedExcluded && selectedExcluded.id === x.id">
        <td>
          {{ x.recipientEnis }} -
          <ng-container *ngIf="x.recipient; else recipientDeleted">
            {{ x.recipient.firstName }} {{ x.recipient.lastName }}
          </ng-container>
          <ng-template #recipientDeleted>
            <em class="historical-text">(Deleted PM-waitlist recipient)</em>
          </ng-template>
        </td>
        <td>
          {{ x.donorEnis }} -
          <ng-container *ngIf="x.donor; else donorDeleted">
            {{ x.donor.firstName }} {{ x.donor.lastName }}
          </ng-container>
          <ng-template #donorDeleted>
            <em class="historical-text">(participant deleted)</em>
          </ng-template>
        </td>
        <td class="hide-xs">{{ x.dateCreated | date }}</td>
        <td>{{ x.reasonExcluded }}</td>
        <td (click)="$event.stopPropagation()">
          <app-rowmenu [comb]="x" (action)="handleAction($event)"></app-rowmenu>
        </td>
      </tr>

      <!-- Details row -->
      <tr *ngIf="selectedExcluded && selectedExcluded.id === x.id" class="details-row">
        <td colspan="5" class="details-cell">
          <div class="excluded-details">
            <div class="details-header">
              <h4>Excluded Combination Details</h4>
              <button type="button" class="close-button" (click)="closeExcludedDetails()" title="Close">×</button>
            </div>
            <div class="details-content">
              <div class="detail-item">
                <strong>Reason Excluded:</strong> {{ x.reasonExcluded }}
              </div>
              <div class="detail-item" *ngIf="x.comments">
                <strong>Comments:</strong>
                <div class="comments-text">{{ x.comments }}</div>
              </div>
              <div class="detail-item" *ngIf="!x.comments">
                <em>No comments available for this excluded combination.</em>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
